<template>
  <layout-gestao v-cloak>
    <div class="row">
      <div class="col-sm-12">
        <form
          autocomplete="off"
          method="post"
          data-vv-scope="form"
          @keyup.enter="() => {}"
          @submit.prevent="saveItem"
        >
          <div class="row mb-3">
            <div class="col-sm-auto">
              <h1 class="content-title">
                {{ titleItem }}
              </h1>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-9">
              <div class="form-group">
                <MaterialInput
                  id="input-name"
                  v-model.trim="form.name"
                  v-validate="'required|min:3'"
                  :readonly="readonlyFormItem"
                  type="text"
                  class="city-form-group city-bg"
                  name="name"
                  :inputClasses="[{'is-invalid': fnHasError('name') }]"
                  :error=" fnFirstError('name')"
                >
                  {{ $t(`${pageID}.model.name`) }}
                </MaterialInput>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <MaterialSelect
                  id="input-status"
                  v-model.trim="form.status"
                  v-validate="'required'"
                  :disabled="readonlyFormItem"
                  class="city-form-group city-bg"
                  name="status"
                  label="name"
                  :filterable="true"
                  :options="lists.onoff"
                  :reduce="option => option.code"
                  :inputClasses="[{'is-invalid': fnHasError('status') }]"
                  :error=" fnFirstError('status')"
                  :helpText="help.status"
                >
                  {{ $t(`${pageID}.model.status`) }}
                </MaterialSelect>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <MaterialInput
                  id="input-page_title"
                  v-model.trim="form.page_title"
                  v-validate=""
                  :readonly="readonlyFormItem"
                  type="text"
                  class="city-form-group city-bg"
                  name="page_title"
                  :inputClasses="[{'is-invalid': fnHasError('page_title') }]"
                  :error=" fnFirstError('page_title')"
                >
                  {{ $t(`${pageID}.model.page_title`) }}
                </MaterialInput>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <MaterialInput
                  id="input-div_title"
                  v-model.trim="form.div_title"
                  v-validate=""
                  :readonly="readonlyFormItem"
                  type="text"
                  class="city-form-group city-bg"
                  name="div_title"
                  :inputClasses="[{'is-invalid': fnHasError('div_title') }]"
                  :error=" fnFirstError('div_title')"
                  :helpText="help.div_title"
                >
                  {{ $t(`${pageID}.model.page_title`) }}
                </MaterialInput>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <MaterialInput
                  id="input-map_title"
                  v-model.trim="form.map_title"
                  v-validate=""
                  :readonly="readonlyFormItem"
                  type="text"
                  class="city-form-group city-bg"
                  name="map_title"
                  :inputClasses="[{'is-invalid': fnHasError('map_title') }]"
                  :error=" fnFirstError('map_title')"
                >
                  {{ $t(`${pageID}.model.map_title`) }}
                </MaterialInput>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <MaterialSelect
                  id="input-module_scale_id"
                  v-model.trim="form.module_scale_id"
                  v-validate="''"
                  :disabled="readonlyFormItem"
                  class="city-form-group city-bg"
                  name="module_scale_id"
                  label="scale"
                  :multiple="false"
                  :filterable="true"
                  :options="lists.scales"
                  :inputClasses="[{'is-invalid': fnHasError('module_scale_id') }]"
                  :error=" fnFirstError('module_scale_id')"
                >
                  {{ $t(`${pageID}.model.scale`) }}
                </MaterialSelect>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <MaterialInput
                  id="input-dpi"
                  v-model.trim="form.dpi"
                  v-validate="'required|integer|min_value:1|max_value:600'"
                  :readonly="readonlyFormItem"
                  type="number"
                  class="city-form-group city-bg"
                  name="dpi"
                  :inputClasses="[{'is-invalid': fnHasError('dpi') }]"
                  :error=" fnFirstError('dpi')"
                >
                  {{ $t(`${pageID}.model.dpi`) }}
                </MaterialInput>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <MaterialInput
                  id="input-crs"
                  v-model.trim="form.crs"
                  v-uppercase
                  v-validate="{ required: true, regex: /^EPSG:\d+$/i }"
                  :readonly="readonlyFormItem"
                  type="text"
                  class="city-form-group city-bg"
                  name="crs"
                  :inputClasses="[{'is-invalid': fnHasError('crs') }]"
                  :error=" fnFirstError('crs')"
                >
                  {{ $t(`${pageID}.model.crs`) }}
                </MaterialInput>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group city-form-group city-bg mb-0">
                <MaterialTextarea
                  id="input-comment"
                  v-model.trim="form.comment"
                  v-validate="'min:3'"
                  :readonly="readonlyFormItem"
                  :disabled="readonlyFormItem"
                  class="city-form-group city-bg mb-0"
                  name="comment"
                  :rows="4"
                  :helpText="help.comment"
                  :inputClasses="[{'is-invalid': fnHasError('comment') }]"
                  :error="fnFirstError('comment')"
                >
                  {{ $t(`${pageID}.model.comment`) }}
                </MaterialTextarea>
              </div>
            </div>
          </div>
          <div>
            <h4 class="mt-4">
              {{ $t(`${pageID}.form.layers`) }}
            </h4>
            <hr>
            <div class="row">
              <div v-if="!readonlyFormItem" class="order-2 order-sm-1 col-12 col-sm-7 col-lg-6">
                <table-data
                  ref="tblResources"
                  tableWrapperClass="py-2 px-1"
                  :startLoad="startLoadResources"
                  :route="url.getResources"
                  :settings="table.settings"
                  :columns="table.columns"
                  :inlineFilters="table.filters"
                  :autoUpdateFilter="table.autoUpdateFilter"
                  :externalFilters="tblFilters"
                  :autoUpdateExternalFilter="table.autoUpdateExternalFilter"
                  :addParamsToUrl="table.addParamsToUrl"
                  :loadingMsg="table.loadingMsg"
                  :notFoundMsg="table.notFoundMsg"
                  :orderByTemplate="table.orderByTemplate"
                  @error-load="showError"
                >
                  <template #filters="{ tableFilters, search }">
                    <form
                      autocomplete="false"
                      @submit.prevent="search"
                      @keyup.enter="search"
                    >
                      <div class="row header">
                        <div class="col-12">
                          <header-list
                            v-model="tableFilters.q"
                            :title="null"
                            :placeholderSearch="searchPlaceholder"
                            headerClass="mb-3"
                          />
                        </div>
                      </div>
                    </form>
                  </template>

                  <template #body="{row, index, remove}">
                    <td :class="table.columns[0].class">
                      <div class="card flex-md-row">
                        <div class="card-body d-flex flex-column align-items-start p-3">
                          <div class="d-flex flex-row align-items-center justify-content-between flex-nowrap w-100  mb-1">
                            <strong class="d-inline-block mb-2 text-primary">{{ row.name }}</strong>
                            <span class="badge" :class="getClassServiceCode(row.service)">
                              {{ getServiceCode(row.service) }}
                            </span>
                          </div>
                          <h5 class="mb-0">
                            {{ row.title?row.title:row.name }}
                          </h5>
                          <p class="card-text mb-auto">
                            {{ row.abstract?row.abstract:help.no_abstract }}
                          </p>
                          <div class="text-right w-100">
                            <a
                              class="card-link"
                              href="#"
                              @click.prevent="addResource(row, index, remove)"
                            >
                            {{ $t(`${pageID}.form.add`) }}
                            </a>
                            <a
                              v-if="enableAddCrossResource(row.service)"
                              class="text-nowrap card-link"
                              :class="getColorServiceCode(row.service)"
                              href="#"
                              @click.prevent="addCrossResource(row, index)"
                            >
                              {{ $t(`${pageID}.form.add_cross`) }}
                            </a>
                          </div>
                        </div>
                      </div>
                    </td>
                  </template>
                </table-data>
              </div>
              <div class="order-1 order-sm-2 col-12 col-sm-5 col-lg-6">
                <div class="row">
                  <div class="col-12">
                    <h5 class="d-flex justify-content-between justify-content-md-start align-items-center mb-3">
                      <span class="text-muted pr-md-4">{{ help.resources_title }}</span>
                      <span class="badge badge-secondary badge-pill">{{ form.resources.length }}</span>
                    </h5>
                    <div class="form-group city-form-group">
                      <small v-if="fnHasError('resources')" class="invalid-feedback d-block">{{ fnFirstError('resources') }}</small>
                    </div>
                    <draggable
                      v-model="form.resources"
                      v-validate="{required: form.plan_id}"
                      tag="div"
                      v-bind="dragOptions"
                      draggable=".list-group-item"
                      name="resources"
                      @start="onDragStart"
                      @end="onDragEnd"
                    >
                      <transition-group
                        v-validate=""
                        tag="ul"
                        class="p-0"
                        type="transition"
                        :name="!drag ? 'flip-list' : null"
                      >
                        <li
                          v-for="(element, idx) in form.resources"
                          :key="element.id"
                          class="list-group-item p-0 border-0"
                          :class="{'cursor-move': !readonlyFormItem}"
                        >
                          <div class="card flex-md-row">
                            <div class="card-body d-flex flex-column align-items-start py-2 px-3">
                              <div class="d-flex flex-row align-items-center justify-content-start w-100">
                                <div class="d-flex flex-column justify-content-between mr-3">
                                  <span class="badge badge-primary mb-2">
                                    {{ element[pivotResources] && element[pivotResources].order ? element[pivotResources].order : 1 }}
                                  </span>
                                  <span
                                    v-if="element.service"
                                    class="badge"
                                    :class="getClassServiceCode(element.service)"
                                  >
                                    {{ getServiceCode(element.service) }}
                                  </span>
                                </div>
                                <div class="w-100">
                                  <div class="d-flex flex-row align-items-center justify-content-between w-100  mb-1">
                                    <span class="d-inline-block text-primary">{{ element.name }}</span>
                                    <i
                                      v-if="!readonlyFormItem"
                                      class="cursor-pointer fa fa-times close"
                                      @click.prevent="removeResource(idx)"
                                    />
                                  </div>
                                  <h6 class="mb-0">
                                    {{ element.title?element.title:element.name }}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </transition-group>
                    </draggable>
                  </div>
                </div>

                <div v-if="enableCrossresources" class="row mt-4">
                  <div class="col-12">
                    <h5 class="d-flex justify-content-between justify-content-md-start align-items-center mb-3">
                      <span class="text-muted pr-md-4">{{ help.crossresources_title }}</span>
                      <span class="badge badge-secondary badge-pill">{{ form.crossresources.length }}</span>
                    </h5>
                    <div class="form-group city-form-group">
                      <small v-if="fnHasError('crossresources')" class="invalid-feedback d-block">{{ fnFirstError('crossresources') }}</small>
                    </div>
                    <draggable
                      v-model="form.crossresources"
                      v-validate="{required: false}"
                      tag="div"
                      v-bind="dragOptions"
                      draggable=".list-group-item"
                      name="crossresources"
                      @start="onDragStartCrossResources"
                      @end="onDragEndCrossResources"
                    >
                      <transition-group
                        v-validate=""
                        tag="ul"
                        class="p-0"
                        type="transition"
                        :name="!dragCrossResources ? 'flip-list' : null"
                      >
                        <li
                          v-for="(element, idx) in form.crossresources"
                          :key="`crossresources-${element.id}`"
                          class="list-group-item p-0 border-0"
                          :class="{'cursor-move': !readonlyFormItem}"
                        >
                          <div class="card flex-md-row">
                            <div class="card-body d-flex flex-column align-items-start py-2 px-3">
                              <div class="d-flex flex-column w-100">
                                <div class="d-flex flex-row align-items-center justify-content-start mb-3 w-100">
                                  <div class="d-flex flex-column justify-content-between mr-3">
                                    <!-- <span class="badge badge-primary mb-2">
                                                                            {{ element[pivotCrossResources] && element[pivotCrossResources].order ? element[pivotCrossResources].order : 1 }}
                                                                        </span> -->
                                    <span
                                      v-if="element.service"
                                      class="badge"
                                      :class="getClassServiceCode(element.service)"
                                    >
                                      {{ getServiceCode(element.service) }}
                                    </span>
                                  </div>
                                  <div class="w-100">
                                    <div class="d-flex flex-row align-items-center justify-content-between w-100  mb-1">
                                      <span class="d-inline-block text-primary">{{ element.name }}</span>
                                      <i
                                        v-if="!readonlyFormItem"
                                        class="cursor-pointer fa fa-times close"
                                        @click.prevent="removeCrossResource(idx)"
                                      />
                                    </div>
                                    <h6 class="mb-0">
                                      {{ element.title ? element.title : element.name }}
                                    </h6>
                                  </div>
                                </div>
                                <div
                                  v-if="element.featuretype && element.featuretype.properties.length"
                                  class="d-flex flex-column justify-content-between"
                                >
                                  <div class="row">
                                    <div class="col">
                                      <div class="form-group">
                                        <MaterialSelect
                                          :id="`input-crossresources-name-${element.id}`"
                                          v-model.trim="element[pivotCrossResources].name_feature_type_property_id"
                                          v-validate="'required'"
                                          :disabled="readonlyFormItem"
                                          class="city-form-group city-bg"
                                          :name="`crossresources-name-${element.id}`"
                                          :options="element.featuretype.properties"
                                          label="name"
                                        >
                                          {{ $t(`${pageID}.form.field_name`) }}
                                        </MaterialSelect>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col">
                                      <div class="form-group">
                                        <MaterialSelect
                                          :id="`input-crossresources-descr-${element.id}`"
                                          v-model.trim="element[pivotCrossResources].descr_feature_type_property_id"
                                          v-validate="''"
                                          class="city-form-group city-bg"
                                          :disabled="readonlyFormItem"
                                          :name="`crossresources-descr-${element.id}`"
                                          :options="element.featuretype.properties"
                                          label="name"
                                        >
                                          {{ $t(`${pageID}.form.field_descr`) }}
                                        </MaterialSelect>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </transition-group>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <buttons-footer
            :enableButtons="!readonlyFormItem"
            :cancelTitle="cancelTitle"
            :submitTitle="submitTitle"
            :isDisabled="isDisabled"
            @save="saveItem(`${moduleInternalCode}.${pageID}`)"
            @cancel="handleBack(`${moduleInternalCode}.${pageID}`, true)"
          />
        </form>
      </div>
    </div>
  </layout-gestao>
</template>

<script>
    import DetailsMixin from '../../../../shared/mixins/DetailsMixin';


    export default {
        mixins: [
            DetailsMixin,
        ],
        data()
        {
            const pageID = 'municipal_interventions_reports';
            return {
            pageID: pageID,
            pageTitle: this.$t(`${pageID}.title`),
                pivotResources: 'resourceprint',
                pivotCrossResources: 'crossresourceprint',
                lists: {
                    scales: [],
                },
                form: {
                    id: null,
                    name: "",
                    status: 1,
                    module_scale_id: null,
                    dpi: 96,
                    crs: null,
                    page_title: null,
                    div_title: null,
                    map_title: null,
                    comment: null,
                    resources: [],
                },
                table: {
                    autoUpdateExternalFilter: false,
                    columns: [
                        {
                            label: 'Nome',
                            field:  'name',
                            class: '',
                            sortable: true,
                        },
                    ],
                },
              }
        },
        watch: {

        },
        methods: {
           loadLists: function() {
                if (!this.lists.loaded) {
                    this.$http.get(this.url.getScales)
                    .then(res => {
                        this.lists.scales = res.data.data;
                        this.lists.loaded = true;
                    })
                    .catch(error => {
                        this.lists.loaded = false;
                        this.showHttpError(error);
                    });
                }
            },
        },
      }
</script>

<style scoped lang="scss">
    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .close {
        font-size: 1rem;
    }
</style>